module.exports = __webpack_public_path__ + "img/004-hosting.12c779d5.svg";